<template>
	<div class="goods-info-body">
		<div class="goods-info-box">
			<div class="basis-info-body">
				<p>
					<span>商品属性</span>
				</p>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="form-box">
					<div class="info-box">
						<el-form-item label="商品名称：" prop="goodsName">
							<el-input :maxlength='50' v-model="ruleForm.goodsName" class="short-input" size="mini" placeholder="请输入商品名称"></el-input>
						</el-form-item>
						<el-form-item label="商品编号：">
							<el-input disabled v-model="ruleForm.code" class="short-input" size="mini" @input="codeInput" :maxlength="15" placeholder="请输入商品编号"></el-input>
						</el-form-item>
						<el-form-item label="店铺分类：" prop='category' ref="category" class="category-box">
							<el-select v-model="ruleForm.bigCategory" class='short-input' size="mini" placeholder="请选择店铺级大类" @change="bigCategoryChange('ruleForm')">
								<template v-for="(item) in bigCategoryList">
									<el-option
										:value="item.bc_id"
										:label="item.bc_name"
										:key="item.bc_id"
										:disabled="item.disabledflag"/>
								</template>
							</el-select>
							<el-select v-model="ruleForm.smallCategory" class='short-input' v-if="bigcategoryview === 1" size="mini" placeholder="请选择店铺级小类" @change="smallCategoryChange('ruleForm')">
								<template v-for="(item) in smallCategoryList">
									<el-option
										:key="item.id"
										:label="item.name"
										:value="item.id"
										:disabled="item.disabledflag">
									</el-option>
								</template>
							</el-select>
						</el-form-item>
					</div>
					<div class="info-box">
						<el-form-item label="中台商品名称：" class='state-box'>
							<div style="font-size: 12px;">{{productInfo.matchname}}</div>
						</el-form-item>
						<el-form-item label="启用状态：">
							<div style="width: 80px;font-size: 12px;">{{ruleForm.startRadio ? '禁用' : '启用'}}</div>
						</el-form-item>
						<el-form-item label="私密状态：" prop="privateRadio" class="state-box">
							<el-radio v-model="ruleForm.privateRadio" :label="false">公开</el-radio>
							<el-radio v-model="ruleForm.privateRadio" :label="true">私密</el-radio>
						</el-form-item>
						<el-form-item label="店内显示顺序：">
							<div style="width: 400px;">
								<el-input v-model="ruleForm.shopSeqnum" class="short-input" size="mini" @input="orderInput"></el-input>
								<span style="color:#606266;font-size: 12px;">（数值越大，越靠前显示）</span>
							</div>
						</el-form-item>
					</div>
					<div class="info-box">
						<el-form-item label="商品介绍：" style="display:block" class="textarea-box">
							<el-input class='long-input' type="textarea" v-model="ruleForm.goodsExplain" :rows='5' :maxlength='300'></el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="show-img-body">
				<ShowImg :imgInfo='imgInfo' :videoInfo='videoInfo' ref="showImgRef"/>
				<AttrInfo ref="attrInfo" :productDetails="productDetails"/>
			</div>
			<div class="goods-status-box">
				<setSpec ref="setSpec" :showInventory='showInventory' :SKUValue="SKUValue" :SKUType="specTypeDTOs"  :productId="productId"/>
			</div>
		</div>
		<div class="btn-box1">
			<el-button class="btn" size='small' type="primary" v-show="true" @click="saveInfo">保存</el-button>
		</div>
	</div>
</template>

<script>
// import ImgUpload from '@/components/goodsManagement/goodsInfo/ImgUpload.vue'
import ShowImg from '@/components/dock/ShowImg.vue'
import AttrInfo from '@/components/dock/AttrInfo.vue'
import setSpec from '@/components/dock/setSpec.vue'
export default {
	name: 'goodsInfo',
	components: {
		// ImgUpload,
		ShowImg,
		AttrInfo,
		setSpec
	},
	data () {
		var category = (rule, value, callback) => {
			if (this.isTrue === true) {
				return callback(new Error('店铺分类不能为空'))
			} else {
				callback()
			}
		}
		return {
			showInventory: false,
			matchid: '',
			enterprise: '',
			specTypeDTOs: [],

			hiddenFlag: 0,
			productId: '',
			goodsid: '',
			shopid: '',
			saleState: 1,
			auditShopCount: 0,
			statusIcon: 'submit',
			isTrue: true,
			checked: false,
			bigCategoryList: [],
			smallCategoryList: [],
			relatedStatus: false,
			ruleForm: {
				goodsName: '',
				bigCategory: '',
				smallCategory: '',
				goodsExplain: '',
				code: '',
				shopSeqnum: 0,
				startRadio: false,
				privateRadio: false
			},
			rules: {
				goodsName: [
					{ required: true, message: '请输入1~50个字范围内的商品名称', trigger: 'blur' }
				],
				code: [
					{ required: true, message: '请输入1～15个英文数字范围内的商品编号', trigger: 'blur' }
				],
				category: [
					{ required: true, validator: category, trigger: 'blur' }
				],
				startRadio: [
					{ required: true, message: '', trigger: 'blur' }
				],
				privateRadio: [
					{ required: true, message: '', trigger: 'blur' }
				]
			},
			productInfo: {},
			productDetails: [],
			imgInfo: [],
			videoInfo: [],
			SKUValue: [],
			showSrc: [
				{ src: '', location: '1', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '2', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '3', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '4', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '5', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '6', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '7', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '8', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '9', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '10', id: '0', uploadError: false, imgtype: 1 }
			],
			editDisable: true,
			pxcode: '',
			pxname: '',
			pxstopflag: false,
			clddock: 1,
			sourceflag: false,
			itemId: '',
			bigcategoryview: 0
		}
	},
	created () {
		this.matchid = this.$route.query.id
		this.enterprise = this.$route.query.enterprise
		this.getGoodsInfo()
	},
	methods: {
		orderInput () {
			this.ruleForm.shopSeqnum = this.ruleForm.shopSeqnum.replace(/[^\d-]/g, '')
			if (this.ruleForm.shopSeqnum.lastIndexOf('-') > 0) {
				let numArr = this.ruleForm.shopSeqnum.split('')
				numArr.splice(this.ruleForm.shopSeqnum.lastIndexOf('-'), 1)
				this.ruleForm.shopSeqnum = numArr.join('')
			}
		},
		codeInput () {
			this.ruleForm.code = this.ruleForm.code.replace(/\\|\'|[\u4E00-\u9FA5]/g, '')
		},
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				var params = {
					syscodeid: this.syscodeid
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQNV}/match/matchorganinfo/checkSmallCategoryIsUser`,
					data: params
				}).then(res => {
					resolve(res)
				})
			})
		},
		goodsNameBlur () {
			this.ruleForm.goodsName = this.ruleForm.goodsName.trim()
		},
		getBigCategory () {
			var params = {
				syscodeid: this.syscodeid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQNV}/match/getBigCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.bigCategoryList = res.data
				}
			})
		},
		getSmalCategory () {
			return new Promise((resolve, reject) => {
				let params = {
					pid: this.ruleForm.bigCategory,
					syscodeid: this.syscodeid
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQNV}/match/getSmalCategory`,
					data: params
				}).then(res => {
					if (res.result) {
						this.smallCategoryList = res.data
						resolve(res)
					}
				})
			})
		},
		bigCategoryChange (data) {
			this.ruleForm.smallCategory = ''
			this.categoryChange(data)
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		smallCategoryChange (data) {
			this.categoryChange(data)
		},
		categoryChange (formName) {
			if (this.ruleForm.bigCategory === '' || (this.bigcategoryview === 1 && this.ruleForm.smallCategory === '')) {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			this.$refs[formName].validateField('category', (error) => {
				if (!error) {
					console.log('OK')
				} else {
					return false
				}
			})
		},
		saveInfo (type) {
			this.$refs['ruleForm'].validate((valid) => {
				if (!valid) {
					this.$message.error('请完善商品属性信息！')
					return false
				} else {
					this.savePost(type)
				}
			})
		},
		translateImgArr (func) {
			return new Promise((resolve, reject) => {
				let previewArr = this.showSrc.reduce((pre, cur, index) => {
					let curSrc = this.$refs.showUpload[index][func]()
					if (curSrc) {
						pre.push(curSrc)
					}
					return pre
				}, [])
				if (previewArr.length === 0) {
					reject(previewArr)
				} else {
					resolve(previewArr)
				}
			})
		},
		savePost (type) {
			let showImgRef = this.$refs.showImgRef
			let attrInfo = this.$refs.attrInfo
			let setSpec = this.$refs.setSpec
			if (this.ruleForm.shopSeqnum !== '' && (+this.ruleForm.shopSeqnum < -9999 || +this.ruleForm.shopSeqnum > 9999)) {
				this.$message.error('商品显示顺序为－9999～9999范围内，请重新设置商品显示顺序！')
				return false
			}
			let defaultNum = 0
			for (let i = 0; i < setSpec.tableData.length; i++) {
				let e = setSpec.tableData[i]
				if (+e.price < 0 || +e.price > 9999.99) {
					this.$message.error('【' + e.spec + '】【' + e.code + '】的销售价在0~9999.99范围内、且最大2位小数！')
					return false
				}
				if (e.minbuycnt === '') {
					this.$message.error('【' + e.spec + '】【' + e.code + '】的最小订货数不能为空！')
					return false
				}
				if (+e.minbuycnt < 0 || +e.minbuycnt > 9999) {
					this.$message.error('【' + e.spec + '】【' + e.code + '】的最小订货数在0~9999范围内！')
					return false
				}
				if (+e.minbuycnt < 0 || +e.minbuycnt > 9999) {
					this.$message.error('【' + e.spec + '】【' + e.code + '】的最小订货数在0~9999范围内！')
					return false
				}
				if (+e.weight < 0 || +e.weight > 9999999.999) {
					this.$message.error('【' + e.spec + '】【' + e.code + '】的重量在0~9999999.999范围内！')
					return false
				}
				if (e.defaultflag) {
					defaultNum += 1
				}
			}
			if (setSpec.tableData.length !== 0 && defaultNum === 0) {
				this.$message.error('该商品没有默认规格，保存失败')
				return false
			}

			let productDetailsList = [
				{
					'name': '商品产地',
					'val': attrInfo.ruleForm.goodsProductPlace,
					'seqnum': 0
				}, {
					'name': '包装清单',
					'val': attrInfo.ruleForm.packList,
					'seqnum': 10
				},	{
					'name': '保质期',
					'val': attrInfo.ruleForm.qualityDate,
					'seqnum': 20
				},	{
					'name': '厂商名称',
					'val': attrInfo.ruleForm.venderName,
					'seqnum': 30
				},	{
					'name': '贮存条件',
					'val': attrInfo.ruleForm.storage,
					'seqnum': 40
				}
			]
			showImgRef.showSrc.forEach((item, index) => {
				item.defaultflag = index === 0 ? 1 : 0
				item.seqnum = '' + (index + 1)
			})
			let videoMap = [
				{
					id: showImgRef.videoId,
					oldurl: showImgRef.videoOldUrl,
					newurl: showImgRef.videoNewUrl,
					seqnum: 1,
					defaultflag: 1
				}
			]
			let params = {
				matchid: this.matchid,
				matchcode: this.matchcode,
				matchname: this.matchname,
				syscodeId: this.syscodeid,
				specTypeDTOs: this.specTypeDTOs,

				id: this.productId || null,
				shopId: this.shopid,
				categoryId: this.ruleForm.bigCategory,
				scId: this.bigcategoryview === 1 ? this.ruleForm.smallCategory : 0,
				name: this.ruleForm.goodsName,
				code: this.ruleForm.code,
				seqnum: this.ruleForm.shopSeqnum,
				detailinfo: this.ruleForm.goodsExplain,
				disabledflag: this.ruleForm.startRadio,
				hiddenflag: this.ruleForm.privateRadio,
				productDetailsList: productDetailsList,
				imgMap: showImgRef.showSrc,
				videoMap: videoMap,
				productAttrPlanDTOS: setSpec.tableData
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQNV}/match/saveProduct`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')

					this.getGoodsInfo()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		uploadAsync: async function (uploadFileArr) {
			for (let i = 0; i < uploadFileArr.length; i++) {
				await this.$refs.showUpload[uploadFileArr[i] - 1].uploadImgHandler()
			}
			this.$message.success('保存成功！')
		},
		getGoodsInfo () {
			let params = {
				id: this.matchid,
				enterprise: this.enterprise
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQNV}/match/getBillCenterProduct`,
				data: params
			}).then(res => {
				if (res.result) {
					this.matchcode = res.data.product.matchcode
					this.matchname = res.data.product.matchname
					this.productId = res.data.product.pid
					this.syscodeid = res.data.syscodeid
					this.shopid = res.data.shopid
					this.getBigCategory()
					this.specTypeDTOs = res.data.SKUType


					res.data.SKUValue.forEach(e => {
						e.price = this.$fxUtils.toFixedSHW(e.price, 2)
						e.matchprice = this.$fxUtils.toFixedSHW(e.matchprice, 2)
						e.checked = false
					})
					this.productInfo = res.data.product
					this.ruleForm.goodsName = res.data.product.pname
					this.ruleForm.code = res.data.product.pcode
					this.ruleForm.bigCategory = res.data.product.bcid
					this.ruleForm.smallCategory = res.data.product.bccid
					if (this.ruleForm.smallCategory) {
						this.isTrue = false
					}
					this.ruleForm.startRadio = res.data.product.disabledflag
					this.ruleForm.privateRadio = res.data.product.hiddenflag
					this.ruleForm.shopSeqnum = res.data.product.seqnum
					this.ruleForm.goodsExplain = res.data.product.detailinfo
					this.productDetails = res.data.productDetails
					this.imgInfo = res.data.img
					this.videoInfo = res.data.video
					res.data.SKUValue.forEach(e => {
						if (e.price === 0) {
							e.price = '0.00'
						}
						if (e.weight === 0) {
							e.weight = '0.000'
						}
					})
					this.SKUValue = res.data.SKUValue
					this.checkSmallCategory().then(res => {
						this.showInventory = res.actualtimeinventoryflag !== 1
						this.bigcategoryview = res.bigcategoryview
						if (this.bigcategoryview === 1) {
							this.getSmalCategory()
						} else {
							this.isTrue = true
						}
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		}
	}
}
</script>
<style lang="stylus">
	.category-box .el-form-item__content {
		width: 540px
	}
	.textarea-box .el-form-item__content {
		width: 300px
	}
	.state-box .el-form-item__content {
		width: 220px
	}
</style>
<style lang="stylus" scoped>
.goods-info-body {
	background-color :#FFFFFF;
	overflow :auto;
	display: flex;
	flex: 1;
	flex-direction column
	font-size 12px
	/deep/.el-form-item.is-success .el-input__inner {
		border-color: #DCDFE6
	}
	/deep/.el-form-item__label {
		font-size :12px;
	}
	/deep/.el-radio__label{
		font-size :12px !important
	}
	.goods-info-box {
		overflow-y auto
		display flex
		flex 1
		flex-direction column
		.basis-info-body {
			padding-top: 20px
			box-sizing border-box
			border-bottom: 1px solid #dce2fd
			text-align left
			p {
				height 20px
				line-height 20px
				border-left 4px solid var(--fx-primary-color)
				padding-left 8px
				position relative
				color: #9E9C9D
				font-size 15px
				span {
					&:first-child {
						font-size 15px
						color: #2c3e50
					}
					&:nth-of-type(2) {
						margin: 0 30px;
					}
				}
				.el-button {
					position absolute
					margin-left 30px;
					top: -4px;
				}
			}
			.form-box {
				display flex
				flex-direction: column
				padding-top 10px
				.info-box {
					display: flex
					width: 100%
					min-width: 1000px
					margin-bottom: 15px;
					.short-input {
						width: 200px
						&:nth-of-type(1) {
							margin-right 20px
						}
					}
				}
				.status {
					flex: 7
					.status-icon {
						display inline-block
						width: 108px
						height: 56px
					}
					.pass {
						background-image: url('~images/icon/pass.png')
					}
					.pending {
						background-image: url('~images/icon/pending.png')
					}
					.reject {
						background-image: url('~images/icon/reject.png')
					}
					.submit {
						background-image: url('~images/icon/submit.png')
					}
				}
			}
		}
		.show-img-body {
			// padding: 20px 0
			min-height: 440px
			box-sizing border-box
			border-bottom: 1px solid #dce2fd
			text-align left
			display flex
			.img-box {
				flex: 1
				p {
					height 20px
					font-size 14px
					line-height 20px
					border-left 4px solid var(--fx-primary-color)
					padding-left 8px
				}
				.img-container {
					max-width: 600px
				}
				.img-tips {
					padding: 20px 0 20px 12px
					color: #a7a7a7
				}
			}
		}
		.goods-status-box {
			text-align left
			p {
				height 20px
				font-size 14px
				line-height 20px
				border-left 4px solid var(--fx-primary-color)
				padding-left 8px
				margin 20px 0
			}
			span {
				color: red
				margin-right 6px
			}
		}
	}
	.btn-box1 {
		padding: 20px
		text-align right
		.btn {
			width :130px;
			height :35px;
			margin-left :20px;
		}
	}
}

</style>
